import { render, staticRenderFns } from "./OrderReviewer.vue?vue&type=template&id=46503589&scoped=true"
import script from "./OrderReviewer.vue?vue&type=script&lang=js"
export * from "./OrderReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46503589",
  null
  
)

export default component.exports